import React, { Component } from 'react'
import ListPeople from '../../Services/Queries/ListPeople'
import AddPeopleToPeopleService from '../../Services/Mutations/AddPeopleToPeopleService'
import { Auth } from 'aws-amplify'
import { Button, Modal } from 'react-bootstrap'

class TemplatePeople extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchQuery: '',
      peopleList: [],
      limit: 20,
      nextToken: null,
      selectedPeople: [],
      modalVisible: false,
      sectionLabel_Te: '',
      sectionLabel_Hi: '',
      sectionLabel_En: '',
    }
    this.sectionLabelLanguages = ['Te', 'Hi', 'En']
  }
  getPeopleLists = async (searchQuery) => {
    const input = {
      limit: this.state.limit,
    }
    if (searchQuery) {
      input.search = searchQuery
    }
    const data = await ListPeople(input)
    this.setState({
      peopleList: data.items,
      nextToken: data.nextToken,
    })
  }
  getNextPeopleLists = async () => {
    const input = {
      limit: this.state.limit,
      nextToken: this.state.nextToken,
    }
    const data = await ListPeople(input)
    this.setState({
      spinner: false,
      peopleList: [...this.state.peopleList, ...data.items],
      nextToken: data.nextToken,
    })
  }
  onChangeSearch = (searchQuery) => {
    this.setState({ searchQuery: searchQuery })
    this.getPeopleLists(searchQuery)
  }
  async componentDidMount() {
    this.getPeopleLists()
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedTab != this.props.selectedTab && this.props.selectedTab == 'People') {
      this.setState({ searchQuery: '' })

      this.getPeopleLists()
    }
  }
  buttonVisibilityFunc = () => {
    return this.state.selectedPeople.length
  }
  selectPeople = (People) => {
    const index = this.state.selectedPeople.findIndex((item) => item == People.SK)
    const selectedPeople = this.state.selectedPeople
    if (index == -1) {
      selectedPeople.push(People)
    } else {
      selectedPeople.splice(index, 1)
    }
    this.setState({ selectedPeople: selectedPeople })
  }
  buttonVisibilityFunc2 = () => {
    return this.hasSectionlabelError()
  }
  addPeople = async () => {
    const urlParams = window.location.href.split('?')

    const peopleValue = urlParams && urlParams[1]
    const input = {
      sectionPosition: this.props.sectionPosition,
      sectionLabel_Te: this.state.sectionLabel_Te,
      sectionLabel_En: this.state.sectionLabel_En,
      sectionLabel_Hi: this.state.sectionLabel_Hi,
    }
    let data
    if (this.props.type == 'people') {
      input.peopleValue = this.props.peopleValue
      input.addedpeople = this.state.selectedPeople

      // data = await AddPeopleToPeopleService(input)
    }
    this.setState({ modalVisible: false })
    this.props.closeListCollectionModal()

    //  else if (this.props.type == 'page') {
    //   input.pageValue = this.props.pageValue
    //   data = await AddPeopleToPageService(input)
    // }
    // if (data && (data.statusCode == 'A289' || data.statusCode == 'A290')) {
    //   this.setState({ modalVisible: false, spinner: false }, () => {
    //     this.props.navigation.goBack()
    //   })
    // } else {
    //   this.setState({ modalVisible: false, spinner: false })
    // }
  }
  _rowRenderer(item) {
    const index = this.state.selectedPeople.findIndex((people) => people.SK == item.peopleValue)
    const backgroundColor = index != -1 ? '#999999' : null

    return (
      <div>
        <div
          style={{ marginBottom: '5px', backgroundColor: backgroundColor }}
          onClick={() => {
            this.selectPeople(item)
          }}
        >
          <img
            style={{ width: '30px', height: '30px', borderRadius: '20px', marginRight: '5px' }}
            src={item.peopleCoverImage}
          />
          <text>{item.peopleName}</text>
        </div>
      </div>
    )
  }
  loadMore = async () => {
    await this.getNextPeopleLists()
  }
  handlePeople = () => {
    this.props.addPeople(this.state.selectedPeople)
  }
  closeModal = () => {
    this.setState({ modalVisible: false })
  }
  handleHiSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ sectionLabel_Hi: sectionLabel })
  }
  handleEnSectionLabel = (e) => {
    const sectionLabel = e.target.value
    this.setState({ sectionLabel_En: sectionLabel })
  }
  handleTeSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ sectionLabel_Te: sectionLabel })
  }
  hasSectionlabelError = () => {
    return this.state.sectionLabel_Te || this.state.sectionLabel_En || this.state.sectionLabel_Hi
  }
  renderModal = () => {
    const { sectionLabel_En, sectionLabel_Hi, sectionLabel_Te } = this.state
    return (
      <div>
        <Modal show={this.state.modalVisible} onHide={() => this.closeModal()}>
          <Modal.Body>
            <div>
              <label for='text'>sectionLabel_En</label>
              <div>
                <input
                  type='text'
                  onChange={(e) => {
                    this.handleEnSectionLabel(e)
                  }}
                  value={sectionLabel_En}
                  placeholder='Please Enter sectionLabel_En'
                ></input>
              </div>
            </div>
            <div>
              <label for='text'>sectionLabel_Te</label>
              <div>
                <input
                  type='text'
                  onChange={(e) => {
                    this.handleTeSectionLabel(e)
                  }}
                  value={sectionLabel_Te}
                  placeholder='Please Enter sectionLabel_Te'
                ></input>
              </div>
            </div>
            <div>
              <label for='text'>sectionLabel_Hi</label>
              <div>
                <input
                  type='text'
                  onChange={(e) => {
                    this.handleHiSectionLabel(e)
                  }}
                  value={sectionLabel_Hi}
                  placeholder='Please Enter sectionLabel_Hi'
                ></input>
              </div>
            </div>
          </Modal.Body>
          {!this.hasSectionlabelError() ? (
            <text for='text' style={{ color: 'red', fontSize: 10 }}>
              Please Enter Section Label
            </text>
          ) : null}

          <Modal.Footer>
            {this.buttonVisibilityFunc2() ? (
              <Button onClick={() => this.addPeople()}>Submit</Button>
            ) : (
              <Button disabled>Submit</Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
  render() {
    const { peopleList } = this.state
    return (
      <div>
        <label for='gsearch'>Search People:</label>
        <input
          type='text'
          onChange={(e) => {
            this.onChangeSearch(e.target.value)
          }}
          value={this.state.searchQuery}
          placeholder='Enter People Name'
        ></input>
        {peopleList.map((list, index) => {
          return <div>{this._rowRenderer(list)}</div>
        })}
        {this.state.modalVisible ? this.renderModal() : null}
        {this.state.nextToken != null ? (
          <button onClick={() => this.loadMore()}>Load More</button>
        ) : null}
        {this.buttonVisibilityFunc() ? (
          <Button onClick={() => this.handlePeople()}>Continue</Button>
        ) : (
          <Button disabled>Continue</Button>
        )}
      </div>
    )
  }
}
export default TemplatePeople
